import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import EditHighlightLayer from "../components/EditHighlightLayer";
 
 
const EditHighlightPage = () => {
  return (
    <>
   
 
        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Edit Highlight  </h5><Breadcrumb title="Edit Highlight" /></div>
 
        {/* CalendarMainLayer */}
        <EditHighlightLayer />
 
 
    </>
  );
};
 
export default EditHighlightPage;
 
 